import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=be312e9a&"
import script from "./Exhibitions.vue?vue&type=script&lang=js&"
export * from "./Exhibitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports